/*
 * @Author: syc
 * @Date: 2023-04-01 23:24:52
 * @LastEditors: sycyunfc 18565176387@163.com
 * @LastEditTime: 2025-05-11 12:34:31
 * @FilePath: \drug-testing\src\router\index.ts
 * @Description: router
 * Copyright (c) 2023 by song, All Rights Reserved.
 */
import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'HomeIndex',
    meta: {
      keepAlive: true,
      title: '「深微」全流程保障服务'
    },
    component: () =>
      import(
        /* webpackChunkName: 'home' */ '@/views/home/index.vue'
      )
  },
  {
    path: '/activated',
    name: 'ActivatedIndex',
    meta: {
      keepAlive: true,
      title: '已激活'
    },
    component: () =>
      import(
        /* webpackChunkName: 'activated-index' */ '@/views/activated/index.vue'
      )
  },
  {
    path: '/success',
    name: 'SuccessIndex',
    meta: {
      keepAlive: true,
      title: '激活成功'
    },
    component: () =>
      import(
        /* webpackChunkName: 'success-index' */ '@/views/success/index.vue'
      )
  },
  {
    path: '/pdf',
    name: 'PdfIndex',
    meta: {
      keepAlive: false,
      title: '查看附件'
    },
    component: () =>
      import(
        /* webpackChunkName: 'pdf' */ '@/views/pdf/index.vue'
      )
  },
  {
    path: '/wise-heart',
    name: 'WhIndex',
    meta: {
      keepAlive: false,
      title: '「智慧心」无创精准心脏健康保障服务'
    },
    component: () =>
      import(
        /* webpackChunkName: 'wh-index' */ '@/views/wise-heart/index.vue'
      )
  },
  {
    path: '/pub/dt/check',
    name: 'PubDtCheck',
    meta: {
      keepAlive: false,
      title: '「深微」全流程保障服务'
    },
    component: () =>
      import(
        /* webpackChunkName: 'pub-check' */ '@/views/pub/drug-testing/check/index.vue'
      )
  },
  {
    path: '/gz',
    name: 'GzIndex',
    meta: {
      keepAlive: true,
      title: '「深微」全流程保障服务'
    },
    component: () =>
      import(
        /* webpackChunkName: 'gz-index' */ '@/views/gz/index.vue'
      )
  },
  {
    path: '/flyers/video',
    name: 'FlyersVideo',
    meta: {
      keepAlive: false,
      title: '「深微」全流程保障服务'
    },
    component: () =>
      import(
        /* webpackChunkName: 'flyers-video' */ '@/views/flyers/video/index.vue'
      )
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to: any, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = ''
  }

  next()
})

export default router
